import { useTranslation } from "@opendash/core";
import { Form, Select, Tag } from "antd";
import { observer } from "mobx-react-lite";
import Parse, { Role } from "parse";
import React, { useEffect, useState } from "react";
import { _User } from "../../../js/parsegenerated";
import { getUsername } from "../functions/getUsername";

export const SelectUsersAndRoles = observer(
  (props: {
    initialUsers: Parse.Object[];
    initialRoles: Parse.Object[];
    onCancel: Function;
    onOk: Function;
  }) => {
    const t = useTranslation();
    const [users, setUsers] = useState<Parse.Object[]>([]);
    const [roles, setRoles] = useState<Parse.Object[]>([]);
    const { Option, OptGroup } = Select;

    useEffect(() => {
      new Parse.Query("_User").find().then((value) => {
        setUsers(value);
      });
      new Parse.Query(Role).find().then((value) => {
        setRoles(value);
      });
    }, []);

    return (
      <Form.Item
        label={t("maintenance:users.select.form.users.label")}
        name="usersorroles"
        initialValue={props.initialRoles
          .concat(props.initialUsers)
          .map((userorrole) => {
            if (userorrole.className === "_Role") {
              return `role_${userorrole.id}`;
            }
            if (userorrole.className === "_User") {
              return `user_${userorrole.id}`;
            }
            return;
          })}
      >
        <Select
          mode="multiple"
          allowClear
          style={{ width: "100%" }}
          tagRender={tagRender}
          filterOption={(input, option) => {
            return (option?.children ?? "")
              .toString()
              .toLowerCase()
              .includes(input.toLowerCase());
          }}
        >
          <OptGroup label={t("maintenance:groups.select.form.optgroup.label")}>
            {roles.map((role) => (
              <Option key={role.id} value={`role_${role.id}`}>
                {role.get("label")}
              </Option>
            ))}
          </OptGroup>
          <OptGroup label={t("maintenance:users.select.form.optgroup.label")}>
            {users.map((user) => (
              <Option key={user.id} value={`user_${user.id}`}>
                {getUsername(user as _User)}
              </Option>
            ))}
          </OptGroup>
        </Select>
      </Form.Item>
    );
  }
);

const tagRender = observer(
  (props: {
    label: React.ReactNode;
    value: any;
    disabled: boolean;
    onClose: (event?: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    closable: boolean;
  }) => {
    const { label, value, closable, onClose } = props;
    const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
      event.preventDefault();
      event.stopPropagation();
    };
    let color = "default";
    const prefixIdArray = value?.split("_");
    if (prefixIdArray && prefixIdArray[0] === "user") {
      color = "lime";
    }
    if (prefixIdArray && prefixIdArray[0] === "group") {
      color = "orange";
    }
    return (
      <Tag
        color={color}
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
        style={{ marginRight: 3 }}
      >
        {label}
      </Tag>
    );
  }
);
